import {bargainForMyself} from 'api/bargainForMyself.js'
import {bargainForMyFriends} from 'api/bargainHelpFriends.js'
import {nowBuy} from 'api/nowBuy'
import {localstorageSetItem} from 'common/util/localstorageUtil'

export const command = {
  _bargainFormyself (id) {
    return bargainForMyself(id)
  },
  _bargainForMyFriends (id) {
    return bargainForMyFriends(id)
  },
  _bargainHelpFriends () {
    console.log('帮他砍价')
  },
  async _buyNow (handleId, bargainAmount, campaignId, skuId) {
    nowBuy(skuId).then(() => {
      window.location.href = `/account/create_order?yhsd-play-mode-stage=order&campaignId=${campaignId}&bargainAmount=${bargainAmount}`
      localstorageSetItem('campaignId', campaignId)
      localstorageSetItem('bargainAmount', bargainAmount)
    })
  },
  _ropeIn () {
    console.log('帮他拉人')
  }
}



// WEBPACK FOOTER //
// ./src/common/js/command.js